/* eslint-disable */
// /src/pages/MyOrdersPage.jsx
// 마이페이지 > 주문 내역 (미터점 + 가맹점 통합)

import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import PageTopBar from "../components/PageTopBar";
import BrandHeader from "../components/BrandHeader";
import { useDriverStatusContext } from "../context/DriverStatusContext";
import {
    listStoreOrdersByOwnerPhoneE164,
    updateStoreOrderStatus,
} from "../services/storeOrderService";
import {
    listFranchiseStoreOrdersByOwnerPhoneE164,
    updateFranchiseStoreOrderStatus,
} from "../services/franchiseStoreOrderService";
import { fetchProductById } from "../services/storePublicService";
import { fetchFranchiseProductById } from "../services/franchiseStorePublicService";

/* ===== 공통 스타일 ===== */

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #D7E8FF 0%, #EAF3FF 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #F7FAFF;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 16px 20px;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
`;

const InfoText = styled.div`
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
`;

/* 주문 카드 리스트 */
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Card = styled.div`
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 12px 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

const TitleWrap = styled.div`
  min-width: 0;
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 3px;
  line-height: 1.4;
`;

const Meta = styled.div`
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.5;
`;

const Price = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.4;
`;

const CardMiddle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  ${({ status }) => {
        switch (status) {
            case "pending_deposit":
                return `
          background: #FEF3C7;
          color: #92400E;
          border: 1px solid #FACC15;
        `;
            case "paid":
                return `
          background: #DBEAFE;
          color: #1D4ED8;
          border: 1px solid #60A5FA;
        `;
            case "in_progress":
                return `
          background: #ECFEFF;
          color: #0E7490;
          border: 1px solid #67E8F9;
        `;
            case "shipped":
                return `
          background: #DCFCE7;
          color: #166534;
          border: 1px solid #4ADE80;
        `;
            case "completed":
                return `
          background: #E0E7FF;
          color: #3730A3;
          border: 1px solid #A5B4FC;
        `;
            case "cancelled":
                return `
          background: #FEE2E2;
          color: #B91C1C;
          border: 1px solid #FCA5A5;
        `;
            default:
                return `
          background: #E5E7EB;
          color: #4B5563;
          border: 1px solid #D1D5DB;
        `;
        }
    }}
`;

const ExpandButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  font-size: 12px;
  color: #2563eb;
  cursor: pointer;
  padding: 4px 0;
`;

const CardBottom = styled.div`
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.6;
`;

const LabelRow = styled.div`
  display: flex;
  gap: 6px;
`;

const LabelKey = styled.div`
  width: 70px;
  flex-shrink: 0;
  color: #9ca3af;
`;

const LabelValue = styled.div`
  flex: 1;
  white-space: pre-line;
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 6px;
`;

const SmallButton = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  color: #4b5563;
`;

const PrimarySmallButton = styled.button`
  appearance: none;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  color: #ffffff;
`;

const EmptyBox = styled.div`
  margin-top: 40px;
  padding: 24px 14px;
  border-radius: 16px;
  border: 1px dashed #d1d5db;
  background: #ffffff;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
  line-height: 1.7;
`;

/* 입금 계좌 섹션 */
const SectionLabel = styled.h3`
  margin: 10px 0 2px;
  font-size: 14px;
  color: #0f172a;
  font-weight: 800;
`;

const SectionDivider = styled.hr`
  height: 1px;
  border: 0;
  background: #E5EAF5;
  margin: 0 0 8px;
`;

const BankBox = styled.div`
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;

  .row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }
  .copy {
    border: 1px solid #D1D5DB;
    background: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
`;

/* ===== 유틸 ===== */

const KRW = (n = 0) => Number(n || 0).toLocaleString("ko-KR") + "원";

const formatDate = (ts) => {
    if (!ts) return "-";
    try {
        const d = ts.toDate ? ts.toDate() : new Date(ts);
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}.${m}.${day}`;
    } catch {
        return "-";
    }
};

const tsToMillis = (ts) => {
    if (!ts) return 0;
    if (ts.toMillis) return ts.toMillis();
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.getTime();
};

const statusLabel = (s) => {
    switch (s) {
        case "pending_deposit":
            return "입금 대기";
        case "paid":
            return "입금 확인 요청";
        case "in_progress":
            return "물품 확인중";
        case "shipped":
            return "발송 완료";
        case "completed":
            return "완료";
        case "cancelled":
            return "취소";
        default:
            return "알 수 없음";
    }
};

/* ===== 메인: 마이페이지 통합 주문 내역 ===== */

export default function MyOrdersPage() {
    const { phoneE164, loading: driverLoading } = useDriverStatusContext();

    const [storeOrders, setStoreOrders] = useState([]);
    const [franchiseOrders, setFranchiseOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submittingId, setSubmittingId] = useState(null);
    const [expandedId, setExpandedId] = useState(null);

    // ✅ 상품 계좌 캐시 (source별 분리)
    const [bankByStoreProductId, setBankByStoreProductId] = useState({});
    const [bankByFranchiseProductId, setBankByFranchiseProductId] = useState({});

    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setLoading(false);
                setStoreOrders([]);
                setFranchiseOrders([]);
                return;
            }

            setLoading(true);
            try {
                const [meterList, franchiseList] = await Promise.all([
                    listStoreOrdersByOwnerPhoneE164(phoneE164, { limitCount: 100 }),
                    listFranchiseStoreOrdersByOwnerPhoneE164(phoneE164, {
                        limitCount: 100,
                    }),
                ]);

                if (cancelled) return;

                setStoreOrders((meterList || []).map((o) => ({ ...o, _source: "store" })));
                setFranchiseOrders(
                    (franchiseList || []).map((o) => ({ ...o, _source: "franchise" }))
                );
            } catch (e) {
                console.error("[MyOrdersPage] list error", e);
                if (!cancelled) {
                    setStoreOrders([]);
                    setFranchiseOrders([]);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        if (!driverLoading) {
            run();
        }

        return () => {
            cancelled = true;
        };
    }, [phoneE164, driverLoading]);

    // ✅ store 주문에서 productId 모아서 bankAccount 로드
    useEffect(() => {
        let cancelled = false;

        const collectStoreProductIds = (list) => {
            const ids = [];
            (list || []).forEach((o) => {
                const items = Array.isArray(o.items) ? o.items : [];
                if (items.length) {
                    items.forEach((it) => {
                        if (it && it.productId) ids.push(String(it.productId));
                    });
                } else if (o && o.productId) {
                    ids.push(String(o.productId));
                }
            });
            return Array.from(new Set(ids)).filter(Boolean);
        };

        (async () => {
            try {
                const ids = collectStoreProductIds(storeOrders);
                if (!ids.length) return;

                const missing = ids.filter(
                    (pid) => !Object.prototype.hasOwnProperty.call(bankByStoreProductId || {}, pid)
                );
                if (!missing.length) return;

                const nextMap = {};
                await Promise.all(
                    missing.map(async (pid) => {
                        try {
                            const p = await fetchProductById(pid);
                            const bank =
                                typeof p?.bankAccount === "string" ? p.bankAccount.trim() : "";
                            nextMap[pid] = bank || "";
                        } catch (e) {
                            console.error("[MyOrdersPage] fetchProductById error", pid, e);
                            nextMap[pid] = "";
                        }
                    })
                );

                if (cancelled) return;

                setBankByStoreProductId((prev) => ({ ...(prev || {}), ...nextMap }));
            } catch (e) {
                console.error("[MyOrdersPage] build store bank map error", e);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [storeOrders, bankByStoreProductId]);

    // ✅ franchise 주문에서 productId 모아서 bankAccount 로드
    useEffect(() => {
        let cancelled = false;

        const collectFranchiseProductIds = (list) => {
            const ids = [];
            (list || []).forEach((o) => {
                const items = Array.isArray(o.items) ? o.items : [];
                if (items.length) {
                    items.forEach((it) => {
                        if (it && it.productId) ids.push(String(it.productId));
                    });
                } else if (o && o.productId) {
                    ids.push(String(o.productId));
                }
            });
            return Array.from(new Set(ids)).filter(Boolean);
        };

        (async () => {
            try {
                const ids = collectFranchiseProductIds(franchiseOrders);
                if (!ids.length) return;

                const missing = ids.filter(
                    (pid) =>
                        !Object.prototype.hasOwnProperty.call(
                            bankByFranchiseProductId || {},
                            pid
                        )
                );
                if (!missing.length) return;

                const nextMap = {};
                await Promise.all(
                    missing.map(async (pid) => {
                        try {
                            const p = await fetchFranchiseProductById(pid);
                            const bank =
                                typeof p?.bankAccount === "string" ? p.bankAccount.trim() : "";
                            nextMap[pid] = bank || "";
                        } catch (e) {
                            console.error(
                                "[MyOrdersPage] fetchFranchiseProductById error",
                                pid,
                                e
                            );
                            nextMap[pid] = "";
                        }
                    })
                );

                if (cancelled) return;

                setBankByFranchiseProductId((prev) => ({ ...(prev || {}), ...nextMap }));
            } catch (e) {
                console.error("[MyOrdersPage] build franchise bank map error", e);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [franchiseOrders, bankByFranchiseProductId]);

    const allOrders = useMemo(() => {
        const merged = [...storeOrders, ...franchiseOrders];
        return merged.sort((a, b) => tsToMillis(b.createdAt) - tsToMillis(a.createdAt));
    }, [storeOrders, franchiseOrders]);

    const handleToggleExpand = (id) => {
        setExpandedId((prev) => (prev === id ? null : id));
    };

    const handleMarkPaid = async (order) => {
        if (!order?.id) return;
        const ok = window.confirm(
            "정말 무통장 입금을 완료하셨나요?\n\n입금 후 잘못 누르셨다면, 고객센터로 연락해 주세요."
        );
        if (!ok) return;

        try {
            setSubmittingId(order.id);

            if (order._source === "franchise") {
                await updateFranchiseStoreOrderStatus(order.id, "paid");
                setFranchiseOrders((prev) =>
                    prev.map((o) => (o.id === order.id ? { ...o, status: "paid" } : o))
                );
            } else {
                await updateStoreOrderStatus(order.id, "paid");
                setStoreOrders((prev) =>
                    prev.map((o) => (o.id === order.id ? { ...o, status: "paid" } : o))
                );
            }

            alert("입금 확인 요청이 등록되었습니다.");
        } catch (e) {
            console.error("[MyOrdersPage] mark paid error", e);
            alert("상태 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        } finally {
            setSubmittingId(null);
        }
    };

    const renderOrderCard = (o) => {
        const created = formatDate(o.createdAt);

        const items = Array.isArray(o.items) ? o.items : [];
        const totalQty = items.length
            ? items.reduce((sum, it) => sum + Number(it.qty || 0), 0)
            : o.qty || 1;

        const itemsOptionText = (() => {
            if (!items.length) {
                const topOpts = Array.isArray(o.optionSelections) ? o.optionSelections : [];
                if (!topOpts.length) return "선택된 옵션 없음";
                return topOpts
                    .map((op) =>
                        op.extraPrice
                            ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})`
                            : `${op.groupName}: ${op.value}`
                    )
                    .join(", ");
            }

            if (items.length === 1) {
                const it = items[0];
                const opts = Array.isArray(it.optionSelections) ? it.optionSelections : [];
                if (!opts.length) return "선택된 옵션 없음";
                return opts
                    .map((op) =>
                        op.extraPrice
                            ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})`
                            : `${op.groupName}: ${op.value}`
                    )
                    .join(", ");
            }

            return items
                .map((it) => {
                    const title = it.productTitle || "";
                    const qty = Number(it.qty || 0);
                    const opts = Array.isArray(it.optionSelections) ? it.optionSelections : [];
                    if (!opts.length) return `${title} · 수량 ${qty}개 — 옵션 없음`;
                    const optText = opts
                        .map((op) =>
                            op.extraPrice
                                ? `${op.groupName}: ${op.value} (+${KRW(op.extraPrice)})`
                                : `${op.groupName}: ${op.value}`
                        )
                        .join(", ");
                    return `${title} · 수량 ${qty}개 — ${optText}`;
                })
                .join("\n");
        })();

        const ordererLine = o.orderer ? `${o.orderer.name || ""} / ${o.orderer.phone || ""}` : "-";

        const receiverAddr = o.receiver
            ? `${o.receiver.addr1 || ""} ${o.receiver.addr2 || ""}`.trim()
            : "";

        const canMarkPaid = o.status === "pending_deposit";

        const sourceLabel = o._source === "franchise" ? "가맹점 스토어" : "미터점 스토어";

        const showShippingInfo =
            (o.status === "shipped" || o.status === "completed") &&
            (o.shippingCarrier || o.shippingTrackingNo || o.shippingShipDate);

        const cardId = `${o._source}_${o.id}`;

        // ✅ 계좌 텍스트 구성(상품 bankAccount only, 멀티아이템 지원)
        const bankText = (() => {
            const map = o._source === "franchise" ? bankByFranchiseProductId : bankByStoreProductId;

            if (items.length) {
                const lines = items
                    .map((it) => {
                        const pid = it?.productId ? String(it.productId) : "";
                        if (!pid) return "";
                        const bank = map?.[pid] || "";
                        if (!bank) return "";
                        const title = it.productTitle || it.productTitleSnapshot || "상품";
                        return `${bank}`;
                    })
                    .filter(Boolean);

                return Array.from(new Set(lines)).join("\n");
            }

            const pid = o?.productId ? String(o.productId) : "";
            if (!pid) return "";
            return map?.[pid] || "";
        })();

        const canShowBank = !!bankText;

        return (
            <Card key={cardId}>
                <CardTop>
                    <TitleWrap>
                        <Title>{o.productTitleSnapshot || "상품명 없음"}</Title>
                        <Meta>
                            {sourceLabel} · 주문일 {created} · 수량 {totalQty}개
                        </Meta>
                    </TitleWrap>
                    <Price>{KRW(o.totalPrice || 0)}</Price>
                </CardTop>

                <CardMiddle>
                    <StatusBadge status={o.status}>{statusLabel(o.status)}</StatusBadge>
                    <ExpandButton onClick={() => handleToggleExpand(cardId)}>
                        {expandedId === cardId ? "접기" : "상세 보기"}
                    </ExpandButton>
                </CardMiddle>

                {expandedId === cardId && (
                    <>
                        <CardBottom>
                            <LabelRow>
                                <LabelKey>옵션</LabelKey>
                                <LabelValue>{itemsOptionText}</LabelValue>
                            </LabelRow>
                            <LabelRow>
                                <LabelKey>주문자</LabelKey>
                                <LabelValue>{ordererLine}</LabelValue>
                            </LabelRow>
                            <LabelRow>
                                <LabelKey>배송지</LabelKey>
                                <LabelValue>
                                    {o.receiver?.name
                                        ? `${o.receiver.name} / ${o.receiver.phone || ""}\n${receiverAddr}`
                                        : "-"}
                                </LabelValue>
                            </LabelRow>
                            {o.receiver?.memo ? (
                                <LabelRow>
                                    <LabelKey>요청사항</LabelKey>
                                    <LabelValue>{o.receiver.memo}</LabelValue>
                                </LabelRow>
                            ) : null}

                            {showShippingInfo && (
                                <>
                                    <div
                                        style={{
                                            marginTop: 8,
                                            paddingTop: 6,
                                            borderTop: "1px dashed #E5E7EB",
                                        }}
                                    />
                                    <LabelRow>
                                        <LabelKey>택배사</LabelKey>
                                        <LabelValue>{o.shippingCarrier || "-"}</LabelValue>
                                    </LabelRow>
                                    <LabelRow>
                                        <LabelKey>운송장 번호</LabelKey>
                                        <LabelValue>{o.shippingTrackingNo || "-"}</LabelValue>
                                    </LabelRow>
                                    <LabelRow>
                                        <LabelKey>배송 예정일</LabelKey>
                                        <LabelValue>
                                            {o.shippingShipDate ? formatDate(o.shippingShipDate) : "-"}
                                        </LabelValue>
                                    </LabelRow>
                                </>
                            )}

                            {canShowBank ? (
                                <div style={{ marginTop: 6 }}>
                                    <SectionLabel>입금 계좌</SectionLabel>
                                    <SectionDivider />
                                    <BankBox>
                                        <div className="row">
                                            <div style={{ fontWeight: 400, color: "#0f172a", whiteSpace: "pre-line" }}>
                                                {bankText}
                                            </div>
                                            <button
                                                className="copy"
                                                type="button"
                                                onClick={() => {
                                                    navigator.clipboard
                                                        ?.writeText(bankText)
                                                        .then(() => alert("계좌번호를 복사했어요."));
                                                }}
                                            >
                                                계좌 복사
                                            </button>
                                        </div>
                                    </BankBox>
                                </div>
                            ) : null}
                        </CardBottom>

                        <ActionRow>
                            <SmallButton type="button" onClick={() => handleToggleExpand(cardId)}>
                                닫기
                            </SmallButton>
                            {canMarkPaid && (
                                <PrimarySmallButton
                                    type="button"
                                    onClick={() => handleMarkPaid(o)}
                                    disabled={submittingId === o.id}
                                >
                                    {submittingId === o.id ? "처리 중..." : "입금 완료했어요"}
                                </PrimarySmallButton>
                            )}
                        </ActionRow>
                    </>
                )}
            </Card>
        );
    };

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" label="뒤로가기" />

                <Body>
                    <BrandHeader subtitle="주문 내역" />

                    <InfoText>
                        미터점 스토어와 가맹점 스토어에서 주문한 내역을 한 번에 확인할 수 있습니다.
                    </InfoText>

                    {driverLoading ? (
                        <div>불러오는 중…</div>
                    ) : !phoneE164 ? (
                        <EmptyBox>
                            로그인 정보를 찾을 수 없습니다.
                            <br />
                            홈 화면에서 다시 접속해 주세요.
                        </EmptyBox>
                    ) : loading ? (
                        <div>불러오는 중…</div>
                    ) : allOrders.length === 0 ? (
                        <EmptyBox>주문 내역이 없습니다.</EmptyBox>
                    ) : (
                        <List>{allOrders.map(renderOrderCard)}</List>
                    )}
                </Body>
            </Sheet>
        </Wrap>
    );
}
